import request from "@/utils/request";

export default function list(typeId) {
    return request({
        url: `/storeProductSpecification/agency/list/`+typeId,
        method: 'get',
    })
}
